const CELL = 6;
const GRID = 48;
const COLOURS = ["#3ff3ff", "#ff9a2a", "#3ff3ff", "#ff9a2a", "#7df9ff", "#ffb347"];
const DIRS = [[1, 0], [0, 1], [-1, 0], [0, -1]];
const rand = (a, b) => a + Math.random() * (b - a);

const spawn = (s, i) => {
  const d = Math.floor(Math.random() * 4);
  return {
    x: Math.floor(rand(0.15, 0.85) * s.cols), y: Math.floor(rand(0.15, 0.85) * s.rows),
    d, colour: COLOURS[i % COLOURS.length], trail: [], alive: true, fade: 1, acc: 0, speed: rand(0.9, 1.3),
  };
};

const free = (s, x, y) => x >= 0 && y >= 0 && x < s.cols && y < s.rows && !s.occ[y * s.cols + x];

const run = (s, x, y, d, max = 40) => {
  let n = 0;
  while (n < max && free(s, x + DIRS[d][0] * (n + 1), y + DIRS[d][1] * (n + 1))) n++;
  return n;
};

const stepCycle = (s, c) => {
  const options = [0, 1, 3].map((t) => (c.d + t) % 4).map((d) => ({ d, r: run(s, c.x, c.y, d) })).filter((o) => o.r > 0);
  if (!options.length) { c.alive = false; window.__tronDerez = (window.__tronDerez || 0) + 1; return; }
  const ahead = options.find((o) => o.d === c.d);
  const best = options.reduce((a, b) => (b.r > a.r ? b : a));
  const turnSide = options.filter((o) => o.d !== c.d && o.r > 12);
  let ok;
  if (ahead && ahead.r > 8 && !(turnSide.length && Math.random() < 0.025)) ok = c.d;
  else if (turnSide.length && ahead && ahead.r > 8) ok = turnSide[Math.floor(Math.random() * turnSide.length)].d;
  else ok = best.d;
  c.d = ok;
  c.x += DIRS[ok][0];
  c.y += DIRS[ok][1];
  s.occ[c.y * s.cols + c.x] = 1;
  c.trail.push([c.x, c.y]);
};

const clearTrail = (s, c) => c.trail.forEach(([x, y]) => { s.occ[y * s.cols + x] = 0; });

const drawGrid = (ctx, w, h, t) => {
  ctx.fillStyle = "#01040a";
  ctx.fillRect(0, 0, w, h);
  ctx.strokeStyle = "rgba(40,190,255,0.09)";
  ctx.lineWidth = 1;
  ctx.beginPath();
  const off = (t * 6) % GRID;
  for (let x = -off; x < w; x += GRID) { ctx.moveTo(x, 0); ctx.lineTo(x, h); }
  for (let y = -off; y < h; y += GRID) { ctx.moveTo(0, y); ctx.lineTo(w, y); }
  ctx.stroke();
  const hz = ctx.createLinearGradient(0, h * 0.7, 0, h);
  hz.addColorStop(0, "rgba(0,140,255,0)");
  hz.addColorStop(1, "rgba(0,140,255,0.12)");
  ctx.fillStyle = hz;
  ctx.fillRect(0, h * 0.7, w, h * 0.3);
};

const drawCycle = (ctx, c) => {
  if (c.trail.length < 2) return;
  ctx.globalAlpha = c.fade;
  ctx.strokeStyle = c.colour;
  ctx.shadowColor = c.colour;
  ctx.shadowBlur = 14;
  ctx.lineWidth = 2.5;
  ctx.lineJoin = "miter";
  ctx.beginPath();
  c.trail.forEach(([x, y], i) => (i ? ctx.lineTo(x * CELL + 3, y * CELL + 3) : ctx.moveTo(x * CELL + 3, y * CELL + 3)));
  ctx.stroke();
  if (c.alive) {
    const [x, y] = c.trail[c.trail.length - 1];
    ctx.fillStyle = "#ffffff";
    ctx.shadowBlur = 22;
    ctx.fillRect(x * CELL, y * CELL, 6, 6);
  }
  ctx.shadowBlur = 0;
  ctx.globalAlpha = 1;
};

export const tron = {
  id: "tron",
  name: "Tron",
  subtitle: "Neon light-cycles racing across a dark grid",
  init(w, h) {
    const s = { cols: Math.ceil(w / CELL), rows: Math.ceil(h / CELL) };
    s.occ = new Uint8Array(s.cols * s.rows);
    s.cycles = Array.from({ length: 6 }, (_, i) => spawn(s, i));
    window.__tronState = s;
    return s;
  },
  draw(ctx, w, h, t, s, p, k) {
    ctx.globalCompositeOperation = "source-over";
    drawGrid(ctx, w, h, t);
    s.cycles.forEach((c, i) => {
      if (c.alive) {
        c.acc += c.speed * 2.2 * k;
        while (c.acc >= 1 && c.alive) { c.acc -= 1; stepCycle(s, c); }
        if (c.trail.length > 900) { const [x, y] = c.trail.shift(); s.occ[y * s.cols + x] = 0; }
      } else {
        c.fade -= 0.012 * k;
        if (c.fade <= 0) { clearTrail(s, c); s.cycles[i] = spawn(s, i); }
      }
      drawCycle(ctx, c);
    });
  },
};
